module.exports = __webpack_public_path__ + "static/11-366d08376d0e28bbb1f5f560fb5d5649.png";